<template>
  <div class="part-base-wcm-container">
    <div class="form-base">
      <el-form inline size="mini" :model="formData" :rules="rules" ref="baseForm">
        <!--    表单部分   -->
        <div class="form-rows">
          <!-- 基本信息 -->
          <div class="card-model" v-if="formData.id">
            <div class="card-title">基本信息
              <el-link type="primary" icon="el-icon-refresh" @click="refresh()" v-if="formData.id"></el-link>
            </div>
            <div class="form-card">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="订单编号">
                    <div class="span-val"> {{ formData.order_no || '' }}</div>
                  </el-form-item>
                  <el-form-item label="建单人">
                    <span class="span-val"> {{ formData.creator || '' }}</span>
                  </el-form-item>
                  <el-form-item label="创建时间">
                    <span class="span-val"> {{ formData.created_at || '' }}</span>
                  </el-form-item>
                  <el-form-item label="最后修改时间">
                    <span class="span-val"> {{ formData.updated_at || '' }}</span>
                  </el-form-item>
                  <el-form-item>
                    <el-popover placement="bottom-start" width="1200" trigger="click" @show="showLog">
                      <OrderLogs :order-no="formData.order_no" ref="refOrderLog"/>
                      <el-button slot="reference" type="text" icon="el-icon-document"
                                 v-if="userAuth.view_adv_order_logs_div">查看日志
                      </el-button>
                    </el-popover>
                  </el-form-item>
                </el-col>
                <el-col class="tags" :span="24">
                  <el-form-item label="">
                    <el-tag effect="plain" type="primary" v-if="formData.order_type==='regular'">
                      {{ orderTypeFormat(formData.order_type) }}
                    </el-tag>
                    <el-tag v-else type="danger" effect="plain">{{ orderTypeFormat(formData.order_type) }}</el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <el-tag v-if="formData.bool_exec === 1" type="success" effect="plain">已执行</el-tag>
                    <el-tag v-else-if="formData.bool_exec === 0" type="warning" effect="plain">未执行</el-tag>
                    <el-tag v-else type="info">执行状态：未知</el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <el-tag type="primary" effect="plain">回款状态:{{ payStatusFormat(formData.pay_status) }}</el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <el-tag type="primary" effect="plain">发票申请: {{
                        invoiceStatusFormat(formData.invoice_status)
                      }}
                    </el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <el-tag v-if="formData.bool_undo === 1" type="warning" effect="plain">已撤单</el-tag>
                    <el-tag v-else-if="formData.bool_undo === 0" type="primary" effect="plain">未撤单</el-tag>
                    <el-tag v-else type="info" effect="plain">撤单：未知</el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <el-tag v-if="formData.contract_filed === 1" type="success" effect="plain">已归档</el-tag>
                    <el-tag v-else-if="formData.contract_filed === 0" type="warning" effect="plain">未归档</el-tag>
                    <el-tag v-else type="info" effect="plain">归档状态：未知</el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <el-tag v-if="formData.is_mark === 1" type="success" effect="plain">全案营销订单</el-tag>
                    <el-tag v-else type="success" effect="plain">常规订单</el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <el-tag v-if="formData.pid" type="success" effect="plain" :title="`父ID：${formData.pid}`">子订单
                    </el-tag>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 乙方信息 -->
          <party-b ref="partyB" class="card-model" :form-data="formData" :edit-field.sync="editField"
                   @selectEditField="selectEditField"/>

          <!-- 客户信息 甲方 -->
          <party-a ref="partyA" class="card-model" :is-pre-executor="isPreExecutor" :form-data="formData" :edit-field.sync="editField"
                   @selectEditField="selectEditField" @clearEditField="clearEditField"/>

          <!-- 费用信息 -->
          <div class="card-model fee-container">
            <div class="card-title">费用信息</div>
            <div class="form-card">
              <el-form-item label="总含税收入" prop="payment_account">
                <ml-input :value.sync="formData.payment_account" num placeholder="请输入含税收入"
                          prefix-icon="icon-renminbi"/>
              </el-form-item>
              <el-form-item label="不含税收入" prop="untax_amount">
                <ml-input :value.sync="formData.untax_amount" num placeholder="请输入不含税收入" disabled
                          prefix-icon="icon-renminbi"/>
              </el-form-item>

              <el-form-item :label="`\u3000\u3000\u3000备注`" class="form-item-remark">
                <el-input type="textarea" v-model="formData.remark" :autosize="{ minRows: 4, maxRows: 6}"
                          placeholder="可输入备注" maxlength="200" show-word-limit/>
              </el-form-item>
            </div>
          </div>
          <div class="card-model fee-container">
            <div class="card-title">直播需求</div>
            <div class="form-card">
              <el-form-item label="保量/保次" :prop="'money_or_times'">
                <el-radio-group class="money_or_times" v-model="formData.money_or_times"
                                :disabled="formData.id && (!userAuth.can_live_demand_type)"
                                @change="handleChangeDemand">
                  <el-radio-button label="money">保量</el-radio-button>
                  <el-radio-button label="times">保次</el-radio-button>
                  <el-radio-button label="none">不保</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="formData.money_or_times==='times'" label="要求直播次数" :prop="'live_count'">
                <ml-input :value.sync="formData.live_count" int placeholder="请输入要求直播次数"/>
              </el-form-item>
              <el-form-item v-else-if="formData.money_or_times==='money'" label="保量金额" prop="gq_amount">
                <ml-input :value.sync="formData.gq_amount" num placeholder="请输入保量金额"
                          prefix-icon="icon-renminbi"/>
              </el-form-item>
              <el-form-item style="float: right" v-if="userAuth.can_done_adv_order">
                <div class="formCard">项目终止情况：
                  <el-switch
                      v-model="formData.is_done_order"
                      active-text="是"
                      :active-value="1"
                      :inactive-value="0"
                      inactive-text="否">
                  </el-switch>
                </div>
              </el-form-item>
            </div>
          </div>
        </div>

        <!-- 操作 -->
        <div class="op-row">
          <el-form-item>
            <el-button v-if="showOpRow" class="btn-operation btn-pink" icon="el-icon-finished"
                       :loading="onSubmitLoading" @click="onSubmit('baseForm')">
              {{ this.formData.id ? '修改' : '保存' }}
            </el-button>
            <el-button class="btn-operation btn-pink-border" @click="goBack" icon="el-icon-arrow-left">返回</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <el-dialog title="温馨提示" :visible.sync="dialogModify" width="800px" center custom-class="default-table">
      <el-table :data="modifyShowFields" border style="width: 100%" size="mini">
        <el-table-column prop="label" label="/" align="center"></el-table-column>
        <el-table-column prop="old" label="修改前" align="center">
          <template slot-scope="{row}">
            <span style="text-decoration: line-through">{{ row.old }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="new" label="修改后" align="center"></el-table-column>
      </el-table>
      <part-child-orders-table :table-data="tableDataChildOrders" style="margin-top: 10px;"/>

      <h3 style="text-align: center;color: #ff3176;">
        全案营销项目资料修改，此操作会影响所有子订单（以上表格内的订单）将同步更新，确认要修改吗？</h3>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogModify = false">取 消</el-button>
        <el-button type="primary" @click="sureModify">确定修改</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import PartyA from "@/views/adOrder/components/detail/PartBasePartyA";
import PartyB from "@/views/adOrder/components/detail/PartBasePartyB";
import OrderLogs from "@/views/adOrder/components/detail/OrderLogs";
import {gFunc} from "@/globalFunc";
import {getOptionItems} from "@/api/option";
import {saveOrderWcmMain} from "@/api/order";

import PartChildOrdersTable from "./PartChildOrdersTable";
import {queryOrderChildren} from "@/api/adOrder";
import MlInput from "@/components/MlInput/input.vue";

const oldCustomerData = {
  company_id: {label: '乙方Id', value: null, show: false},
  company_name: {label: '乙方', value: null, show: true},
  customer_id: {label: '客户名称', value: null, show: false},
  customer_name: {label: '客户名称', value: null, show: true},
  sale_id: {label: '销售', value: null, show: false},
  sale: {label: '销售', value: null, show: true},
  organization_id: {label: '销售小组', value: null, show: false},
  organization_name: {label: '销售小组', value: null, show: true},
  commerce_id: {label: '招商', value: null, show: false},
  commerce: {label: '招商', value: null, show: true},
  customer_nature: {label: '客户性质', value: null, show: true},
  brand: {label: '品牌', value: null, show: true},
  trade: {label: '行业', value: null, show: true},
  product: {label: '产品', value: null, show: true},
  order_source: {label: '订单来源', value: null, show: true},
  passenger_order_interval: {label: '客单价', value: null, show: true},
  product_category: {label: '品类', value: null, show: true},
  project_name: {label: '项目名称', value: null, show: true},
  strategy_id: {label: '策略', value: null, show: false},
  strategy_name: {label: '策略', value: null, show: true},
  planner_id: {label: '策划', value: null, show: false},
  planner_name: {label: '策划', value: null, show: true},
  medium_id: {label: '媒介', value: null, show: false},
  medium_name: {label: '媒介', value: null, show: true},
  place_of_origin: {label: '产地', value: null, show: true},
};
const rules = {
  company_id: [{required: true, message: '请输入乙方公司名称', trigger: 'change'},],
  customer_name: [{required: true, message: '请输入客户姓名', trigger: 'change'},],
  customer_nature: [{required: true, message: '请选择客户性质', trigger: 'change'},],
  sale_id: [{required: true, message: '请选择销售', trigger: 'change'},],
  executor_id: [{required: true, message: '请选择执行', trigger: 'change'},],
  commerce_id: [{required: true, message: '请选择招商', trigger: 'change'},],
  brand: [{required: true, message: '请输入品牌名称', trigger: 'blur'},],
  order_source: [{required: true, message: '选择订单来源', trigger: 'change'},],
  trade: [{required: true, message: '请选择行业名称', trigger: 'blur,change'},],
  product: [{required: true, message: '请输入产品名称', trigger: 'blur'},],
  payed_timestamp: [{required: true, message: '请选择结款时间', trigger: 'change'},],
  form_of_cooperation: [{required: true, message: '请选择合作形式', trigger: 'change'},],
  product_category: [{required: true, message: '请选择品类', trigger: 'change'},],
  passenger_order_interval: [{required: true, message: '请选择客单', trigger: 'change'},],
  payment_account: [{required: true, message: '请输入含税收入', trigger: 'blur'},],
  project_name: [{required: true, message: '请输入项目名称', trigger: 'blur'},],
  live_count: [{required: true, message: '请输入直播次数', trigger: 'blur'},],
  gq_amount: [{required: true, message: '请输入保量金额', trigger: 'blur'},],
  money_or_times: [{required: true, message: '请选择保量还是保次', trigger: 'blur'},],
  place_of_origin: [
    {required: true, message: '请输入产地', trigger: 'blur'},
  ],
};
export default {
  name: "PartBase",
  components: {MlInput, OrderLogs, PartyA, PartyB, PartChildOrdersTable},
  props: {
    formData: {
      type: Object,
      required: true,
      tax_point: 6.00 // 税点
    },
    type: {
      type: String,
      default() {
        return 'add'
      }
    },
    showAddBtn: {
      type: Boolean,
      default() {
        return false
      }
    },
    isPreExecutor: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      rules,
      editField: '',//当前编辑的字段
      onSubmitLoading: false,
      onTmpSubmitLoading: false,
      dialogModify: false,
      oldCustomerData: {...{}, ...oldCustomerData},
      modifyFields: [],
      tableDataChildOrders: [],
      orderTypeOptions: [
        {label: '冲账订单', value: 'strike'},
        {label: '普通订单', value: 'regular'},
      ],
      boolExecOptions: [
        {label: '已执行', value: 1},
        {label: '未执行', value: 0},
      ],
      payStatusOptions: [
        {label: '已完结', value: 2},
        {label: '部分回款', value: 1},
        {label: '待回款', value: 0},
      ],
      invoiceStatusOptions: [
        {label: '未开票', value: 'none'},
        {label: '部分开票', value: 'part'},
        {label: '全部开票', value: 'done'},
      ],
      guaranteeOptions: [
        {label: '保量', value: 'Y'},
        {label: '不保量', value: 'N'},
      ],

    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    },
    modifyShowFields() {
      return this.modifyFields.filter(_ => _.show)
    },
    showOpRow() {
      // can_update_executed_order
      // 创建：拥有建单权限
      // 修改：1）拥有修改权限 2）若已执行，则需要【编辑已执行的订单】-can_update_executed_order
      if (this.formData.id) {
        if (this.formData.bool_exec === 1) {
          return this.userAuth.can_update_executed_order
        } else
          return this.userAuth.can_update_adv_order
      } else {
        return this.userAuth.can_create_adv_order
      }
    },
    maxKol() {
      if (this.formData.is_mark === 1 && this.formData.form_of_cooperation === '红人全案') {
        return 1
      }
      return 0
    }
  },
  watch: {
    "formData.money_or_times"() {
      this.$refs.baseForm && this.$refs.baseForm.clearValidate()
    },
    "formData.payment_account"() {
      this.formData.untax_amount = this.MathRound(this.formData.payment_account / ((parseFloat(this.formData.tax_point) + 100) / 100))
    }
  },
  created() {
    //加载下拉框数据
    this.getOptions()
  },
  methods: {
    /**
     * 初始话保存旧的客户数据
     * @param formData
     */
    initOldCustomerData(formData) {
      for (let key in oldCustomerData) {
        this.oldCustomerData[key].value = formData[key]
      }
    },
    /**
     * 判断客户变更信息
     * @returns {[]} 修改前后对比信息
     */
    async judgeIsModify() {
      let modifyFields = [];

      const response = await queryOrderChildren(this.formData.id, 0);
      this.tableDataChildOrders = response.model && response.model.data ? response.model.data : [];
      if (!this.tableDataChildOrders.length) {
        // 还没有子订单直接修改  不需要确认
        return [];
      }

      for (let key in oldCustomerData) {
        const newV = this.formData[key] || null;
        const oldV = this.oldCustomerData[key].value;
        if (this.oldCustomerData[key].value !== this.formData[key]) {
          modifyFields.push({
            field: key,
            label: this.oldCustomerData[key].label,
            new: newV,
            old: oldV,
            show: this.oldCustomerData[key].show
          })
        }
      }
      this.modifyFields = modifyFields;
      return modifyFields;
    },
    sureModify() {
      this.dialogModify = false;
      this.onSubmitLoading = true;
      this.formSubmit();
    },
    /**
     * 保存 || 修改 验证
     * @param formName
     * @returns {boolean}
     */
    async onSubmit(formName) {
      //判断红人可选个数
      if (this.formData.artist_ids) {
        const len = this.formData.artist_ids ? this.formData.artist_ids.length : 0
        if (this.maxKol > 0 && len > this.maxKol) {
          //若限制 最多可选红人
          // this.$notify.warning(`最多可选${this.maxKol}个红人`)
          this.$notify.warning(`您选了${this.formData.artist_ids.length}个红人，最多可选${this.maxKol}个红人`)
          return false
        }
      }

      let _this = this;
      const formPartyA = _this.$refs.partyA.validateForm();
      const formPartyB = _this.$refs.partyB.validateForm();
      if (!formPartyA) {
        _this.$notify.warning('客户信息不完善，请仔细核对')
        _this.toAnchorPoint('partyA');
        return false
      }
      if (!formPartyB) {
        _this.$notify.warning('乙方信息不完善，请仔细核对')
        _this.toAnchorPoint('partyB');
        return false
      }

      if (_this.formData.money_or_times === 'money') {
        if (!_this.formData.artist_ids) {
          _this.$notify.warning('保量时，红人名称必填！')
          return false
        }
      }

      if (_this.formData.id) {
        // 修改操作 同时更改子订单信息
        const modifyFields = await _this.judgeIsModify();
        if (modifyFields.length) {
          this.dialogModify = true;
          return false;
        }
      }

      _this.$refs[formName].validate(async (valid) => {
        if (valid) {
          _this.onSubmitLoading = true
          _this.formSubmit()
        } else {
          _this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    /**
     *
     * 1.保次、不保，创建订单时，自动完结。
     2.保量订单，需要手动点完结
     * */
    handleChangeDemand(val) {
      if (val === 'money') {
        this.formData.is_done_order = 0
        // this.$notify.info('保量订单，需要手动点完结：' + val)
      } else {
        this.formData.is_done_order = 1
        // this.$notify.info('保次、不保，创建订单时，自动完结：' + val)

      }
    },
    formSubmit() {
      const h = this.$createElement;
      this.$msgbox({
        title: '提交订单信息',
        message: h('div', null, [
          h('div', null, [
            h('b', {style: 'color: #303133'}, `客户：`),
            h('span', {style: 'color: #ff3176'}, `${this.formData.customer_name}`),
          ]),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `合作形式：`),
            h('span', {style: 'color: #ff3176'}, `${this.formData.form_of_cooperation}`),
          ]),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `红人名称：`),
            h('span', {style: 'color: #ff3176'}, `${this.formData.artist_nm_str}`),
          ]),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `乙方：`),
            h('span', {style: 'color: #ff3176'}, `${this.formData.company_name}`),
          ]),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `销售：`),
            h('span', {style: 'color: #ff3176'}, `${this.formData.sale}`),
          ]),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `总含税收入：`),
            h('span', {style: 'color: #ff3176'}, `${this.moneyFormat(this.formData.payment_account)}`),
          ])
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '提交中...';
            this.onSubmitLoading = true
            let modifyFields = {}
            this.modifyFields.map(_ => {
              if (_.field !== 'company_name') {
                modifyFields[_.field] = _.new
              }
            });

            // //不修改字段：比如直播数据
            // const excludeFields = ['live_count', 'gq_amount',]
            // excludeFields.forEach((field) => {
            //   delete this.formData[field]
            // })

            const response = await saveOrderWcmMain({order: this.formData, modifyFields});
            this.onSubmitLoading = false
            if (response.success) {
              this.$emit('saved', response.model.id)
            } else {
              this.$notify.warning(`保存失败：${response.message || '未知'}`)
            }
            //数据提交后
            done();
            instance.confirmButtonLoading = false;
          } else {
            done();
          }
        }
      })
          .catch(action => {
            this.$message({
              type: 'info',
              message: action === 'cancel'
                  ? '放弃保存'
                  : '停留在当前页面'
            })
            this.onSubmitLoading = false
          });
    },
    showLog() {
      if (this.$refs['refOrderLog'])
        this.$refs['refOrderLog'].getList()
    },
    refresh() {
      if (this.formData.id)
        this.$emit('refresh', this.formData.id)
    },
    goBack() {
      this.$emit('goBack')
    },
    goNewAdd() {
      this.$emit('goNewAdd')
    },
    moneyFormat(val) {
      return gFunc.numberFormat(val, 2, '.', ',', 'round')
    },
    invoiceStatusFormat(val) {
      let item = this.invoiceStatusOptions.find(value => value.value === val)
      return item ? item.label : '未知'
    },
    payStatusFormat(val) {
      let item = this.payStatusOptions.find(value => value.value === val)
      return item ? item.label : '未知'
    },
    orderTypeFormat(val) {
      let item = this.orderTypeOptions.find(value => value.value === val)
      return item ? item.label : '未知'
    },
    //选项配置
    getOptions() {
      getOptionItems(['customer_types', 'customer_natures', 'order_source', 'form_of_cooperation', 'product_category', 'passenger_order_interval',]).then(res => {
        let data = res.model;
        const customerNaturesOptions = []
        const customerTypesOptions = []
        const orderSourceOptions = []
        const poiOptions = []
        const productCategoriesOptions = []
        const focOptions = []
        if (data.customer_natures) {
          Object.keys(data.customer_natures).forEach((k) => {
            customerNaturesOptions.push({label: data.customer_natures[k], value: k})
          })
        }
        if (data.customer_types) {
          Object.keys(data.customer_types).forEach((k) => {
            customerTypesOptions.push({label: data.customer_types[k], value: k})
          })
        }
        if (data.order_source) {
          Object.keys(data.order_source).forEach((k) => {
            orderSourceOptions.push({label: data.order_source[k], value: k})
          })
        }
        if (data.passenger_order_interval) {
          Object.keys(data.passenger_order_interval).forEach((k) => {
            poiOptions.push({label: data.passenger_order_interval[k], value: k})
          })
        }
        if (data.product_category) {
          Object.keys(data.product_category).forEach((k) => {
            productCategoriesOptions.push({label: data.product_category[k], value: k})
          })
        }
        if (data.form_of_cooperation) {
          Object.keys(data.form_of_cooperation).forEach((k) => {
            focOptions.push({label: data.form_of_cooperation[k], value: k})
          })
        }

        // 设置客户资料下拉选项
        this.$refs.partyA && this.$refs.partyA.setOptions({
          customerNaturesOptions,
          customerTypesOptions,
          orderSourceOptions,
          poiOptions,
          productCategoriesOptions,
          focOptions
        })
      })
    },
    // 编辑字段
    selectEditField(field) {
      this.editField = field
    },
    // 清空当前编辑字段
    clearEditField() {
      this.editField = null
    },
    closeSubmitLoading(time = 1000) {
      setTimeout(() => {
        this.onSubmitLoading = false
      }, time)
    },
    /**
     * 滑动
     * @param dom
     */
    toAnchorPoint(dom) {
      const offsetTop = this.$refs[dom].$el.offsetTop - 100 || false
      // Chrome
      document.body.scrollTop = offsetTop
      // Firefox
      document.documentElement.scrollTop = offsetTop
    },
    MathRound(val, precision = 2, returnStr = false) {
      const multiple = Math.pow(10, precision);
      const ret_val = (Math.round(((0 + val) * multiple)) / multiple).toFixed(precision)
      return returnStr ? ("" + ret_val) : +ret_val
    },
  }
}
</script>

<style lang="scss">
.part-base-wcm-container {

  .card-model {
    margin-top: 15px;

    .card-title {
      position: relative;
      padding-left: 55px;
      margin-bottom: 8px;
      color: rgba(50, 50, 50, 1);
      line-height: 24px;
      font-size: 14px;
      font-weight: bold;
      text-align: left;
    }


    .card-title::after {
      content: "";
      position: absolute;
      bottom: 6.5px;
      left: calc(55px - 8px - 6px);
      width: 8px;
      height: 8px;
      background: rgba(224, 63, 61, 1);
      border-radius: 2px;
    }
  }

  .card-model:first-child {
    margin-top: unset;
  }

  .el-form-item:last-child {
    margin-bottom: unset;
  }

  .form-card {
    padding: 24px 20px;
    border-radius: 6px;
    border: 1px solid rgba(221, 221, 221, 1);
    width: 95%;
    margin: 5px auto;
  }

  .form-rows {
    border: 1px solid rgba(221, 221, 221, 1);
    border-radius: 6px;
    padding: 24px 20px;
  }

  .op-row {
    text-align: center;
    vertical-align: middle;
    /*border: 1px solid rgba(221, 221, 221, 1);*/
    border-radius: 6px;
    line-height: 1;
    padding: 24px 20px;
  }

  .btn-operation {
    border-radius: 2px;
    font-size: 14px;
    padding: 12px 20px;
  }

  .edit-btn {
    margin-left: 5px;
  }

  .is-label {
    font-weight: 800;
    color: #606266;
  }

  .is-value {
    font-weight: 400;
    margin-right: 10px;
    color: #606266;
  }

  .rebates_rate::after {
    content: ' %';
  }

  .commission_rate::after {
    content: ' %';
  }

  .commission_trailer::after {
    content: ' %';
  }

  .calc-res {
    font-weight: 600;
    font-size: 1.2em;
    color: #F56C6C;
  }

  .span-val {
    min-width: 120px;
    width: 180px;
    max-width: 300px;
    overflow-x: hidden;
    text-align: center;
    border: 1px solid rgb(220, 223, 230);
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 4px;
    display: inline-block;
    font-size: 1em;
    line-height: 24px;
  }

  .input-val {
    min-width: 120px;
    width: 180px;
    max-width: 300px;
    overflow-x: hidden;
    text-align: center;
    border: 1px solid rgb(220, 223, 230);
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1em;
    line-height: 26px;
  }

  .input-val > .form-val {
    flex: 4;
    text-align: center !important;
    width: 100%;
    padding: 0 10px;
  }

  .input-val > .edit-btn {
    flex: 1;
  }

  .fee-box {
    border: 1px solid rgb(220, 223, 230);
    padding: 10px;
  }

  .bold-label {
    font-weight: bold;
    color: #ff3176;
  }

  .form-card.disabled {
    .input-val {
      background: #f4f4f4;
      color: #636466;
      cursor: not-allowed;
      pointer-events: none; // 禁止点击事件
    }
  }

  .tags {
    .el-tag {
      border-radius: 9px;
      line-height: 16px;
      height: 18px;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.fee-container {
  .el-form-item {
    width: calc((100% - 40px) / 4) !important;

    .el-form-item__content {
      width: calc(100% - 120px);
      margin-left: 0 !important;
    }
  }

  .el-radio-group {
    width: 100%;

    .el-radio-button {
      width: 50%;

      span {
        width: 100%;
      }
    }
  }

  .form-item-remark.el-form-item {
    width: calc(((100% - 40px) / 4) * 3) !important;
    display: block;

    .el-form-item__content {
      width: 60%;
    }
  }

  .form-item-remark.el-form-item:before {
    content: "*";
    opacity: 0;
    margin-right: 4px;
    display: inline;
  }

  .money_or_times {
    .el-radio-button {
      width: calc(100% / 3);
    }
  }
}
</style>
